import React, { useState } from "react";
import ReactSimplyCarousel from 'react-simply-carousel';

const Slider = ({children, responsiveProps}) => {

  const [activeSlide, setActiveSlide] = useState(0);
  return(
    <ReactSimplyCarousel className="flex-nowrap"
        containerProps={{
          style: {
            flexDirection: "initial",
            flexWrap: "nowrap", 
            width: "100%",
            userSelect: "text",
            justifyContent: "center",
            marginBottom: "30px"
          }
        }}
        activeSlideIndex={activeSlide}
        onRequestChange={setActiveSlide}
        forwardBtnProps={{
          children: <div className="slider-arrow right"></div>,
          style: {
            padding: 0,
            width: 37,
            height: 37,
            alignSelf: "center",
            border: "none",
            borderRadius: "50%",
            background: "#000",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }
        }}
        backwardBtnProps={{
          children: <div className="slider-arrow left"></div>,
          style: {
            padding: 0,
            width: 37,
            height: 37,
            alignSelf: "center",
            border: "none",
            borderRadius: "50%",
            background: "#000",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }
        }}
        responsiveProps={responsiveProps}
        speed={400}
        showControls={true}
        hideNavIfAllVisible={true}
      >
        {children}
    </ReactSimplyCarousel>
  )
}

export default Slider;